export const DEVICEREPORT_DEVICE_LIST_LOAD='device/list/FETCH_DEVICE_LIST_LOAD';
export const FETCH_DEVICEREPORT_DEVICE_LIST='device/list/FETCH_DEVICE_LIST';
export const DEVICEREPORT_DEVICE_LIST='device/list/DEVICE_LIST';
export const DEVICEREPORT_DEVICE_CHECK='device/list/DEVICE_CHECK';

